import { Information, UserNav } from 'components'
import { SendHelp } from 'components/SendHelp/Index'
import { useLocation } from 'react-router'
import { useMemo } from 'react'
import { useStyles } from './styles'
import DistributionCenter from 'components/DistributionCenter'

export const Header = () => {
  const { pathname } = useLocation()
  const separationLocation: string[] = ['etapa', 'pedido']
  const classes = useStyles()

  const isSeparating = separationLocation.some(element => pathname.includes(element))

  const isMobile = useMemo(() => {
    return window.innerWidth <= 768
  }, [])

  return (
    <header
      className={`${isSeparating} ? ${classes.header} && ${classes.updatedHeader} : ${classes.header}`}
      data-testid="header"
    >
      <div className={classes.container}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          <Information isSeparating={isSeparating} />
          {!isMobile && <DistributionCenter variant="header" showIcon />}
        </div>

        <div className={classes.signout}>
          <SendHelp />
          <UserNav theme="light" />
        </div>
      </div>
    </header>
  )
}
